<template>
  <RecordingsTable />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import RecordingsTable from "../../components/Recordings/RecordingsTable.vue";

export default defineComponent({
  name: "RecordingsPage",
  components: {
    RecordingsTable
  },
});
</script>